function searchTokens(query: string): string[] {
  return query.match(/[\p{L}\p{N}]+(?:\.[\p{L}\p{N}]+)*/gu) ?? [];
}

function isAsciiAlnumToken(token: string): boolean {
  return /^[A-Za-z0-9]+(?:\.[A-Za-z0-9]+)*$/.test(token);
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function chatSearchPhrasePattern(query: string): RegExp | null {
  const tokens = searchTokens(query);
  if (!tokens.length) return null;

  const gap = '[\\s\\u2018\\u2019\\u201C\\u201D"\'`.,;:!?()\\[\\]-]*';
  const inner = tokens
    .map((token) => {
      const escaped = escapeRegExp(token);
      if (!isAsciiAlnumToken(token)) return escaped;
      if (token.length <= 1) return `\\b${escaped}\\b`;
      return `\\b${escaped}\\w*`;
    })
    .join(gap);

  return new RegExp(`(${inner})`, 'gi');
}

export function chatSearchTokenPattern(query: string, minLength = 1): RegExp | null {
  const tokens = searchTokens(query).filter((token) => token.length >= minLength);
  if (!tokens.length) return null;

  const inner = tokens
    .map((token) => {
      const escaped = escapeRegExp(token);
      if (!isAsciiAlnumToken(token)) return escaped;
      return token.length <= 1 ? `\\b${escaped}\\b` : `\\b${escaped}`;
    })
    .join('|');

  return new RegExp(`(${inner})`, 'gi');
}

export function chatSearchHighlightPattern(query: string, text: string): RegExp | null {
  const phrase = chatSearchPhrasePattern(query);
  if (phrase) {
    phrase.lastIndex = 0;
    if (phrase.test(text)) {
      phrase.lastIndex = 0;
      return phrase;
    }
  }
  return chatSearchTokenPattern(query, 2) ?? chatSearchTokenPattern(query, 1);
}
